import './ButtonLink.scss';

const ButtonLink = ({ title, icon, ...props }) => {
  return (
    <div
      {...props}
      className={
        'inline-flex justify-center items-center button-link gap-4 ' +
        props.className
      }
    >
      <span className="text-body-medium">{title}</span>
      {icon && (
        <span
          className="flex justify-center items-center"
          style={{ width: '14px', height: '14px' }}
        >
          {icon}
        </span>
      )}
    </div>
  );
};

export default ButtonLink;
